module.exports = __webpack_public_path__ + "static/08_Synthesis-process.61c092f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/08_Synthesis-process.jpg
// module id = 483
// module chunks = 110568472390859